import { List, Map, fromJS } from 'immutable';

export function request(state, { userId, uid }) {
    let bets = state.getIn([ 'bets', userId ]) || List();
    let bet = bets.find(x => x.get('uid') === uid);

    bets = bets.filter(x => x.get('uid') !== uid);

    if (bet && bet.get('type') === 'SGL') {
        let legs = state.getIn([ 'legs', userId ]) || Map();

        legs = legs.filter((v, k) => k !== uid);
        bets = bets.filter(x => !x.get('legs').contains(uid));

        state = state.setIn([ 'legs', userId ], legs);
    }

    state = state
        .set('bets', state.get('bets').set(userId, bets));

    return state;
}
